/***
 * Created on 2024/11/27
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React from 'react';
import ModalComponent from "../../common/ModalComonent/ModalComponent";
import {useTranslation} from "react-i18next";
import {useOrganization} from "../../../context/OrganizationContext";
import ic_arrow_drop_down_svg from "../../../static/img/utils/ic-arrow-drop-down.svg";
import ic_nas_0b_t1_svg from "../../../static/img/device/ic_nas_0b_t1.svg.svg";
import {get_primary_email} from "../../../service/common";
import {useMutation} from "@tanstack/react-query";
import {useOrganizationApi} from "../../../hook/OrganizationAPIHook";

function DeviceTransferToQid({openModal, closeModal, dispatch, state}) {
    const { t } = useTranslation();
    const {getCurrentOrg} = useOrganization();
    const {OrganizationAPI} = useOrganizationApi();
    const organization = getCurrentOrg();
    const [agree, setAgree] = React.useState(false);
    // const currentUser = JSON.parse(window.localStorage.getItem('currentUser'));
    const email = get_primary_email(state.device_data.source_user);

    const transferMutation = useMutation({
        mutationFn: async (data) => await OrganizationAPI.device.post(`${state.device_data.device_id}/transfer`, null, data),
        onSuccess: data => {
            dispatch({type: 'toggle_transfer_success', payload: {open: true, data: organization}});
        },
        onError: (error, variables, context) => {
            dispatch({type: 'toggle_transfer_fail', payload: {open: true, data: organization}});
        }
    });

    const onTransfer = async () => {
        console.log('Transfer device back to QNAP ID');
        await transferMutation.mutateAsync({target: 'user'});
        // dispatch({type: 'toggle_transfer_success', payload: {open: true, data: organization}});
        // dispatch({type: 'toggle_transfer_fail', payload: {open: true, data: organization}});
    }

    return (
        <ModalComponent title={t('@Transfer Device Back to QNAP ID@')} isOpen={openModal} onClose={closeModal} okText={t('@Transfer@')} input={{agree}} preSubmit={(i) => i?.agree} onSubmit={async () => await onTransfer()}>
            <div className="dialog-content">
                <div className="text-wrap !mb-24">
                    {t('@You are about to transfer this device from {{org_name}} back to the personal QID associated with {{qid_email}}. Once transferred, the device will no longer be managed by the organization, and only {{qid_email}}. will have access to and control over it.@', {org_name: organization?.name, qid_email: email})}
                </div>
                <div className="flexbox-table min-h-auto disable-interaction">
                    <div className="flexbox-thead">
                        <div className="thead-cell !w-40">
                            <div className="sort sort-disabled">
                                <span className="sort-label">{t('@Device name@')}</span>
                                <span className="sort-arrow"><img src={ic_arrow_drop_down_svg} alt=""/></span>
                            </div>
                        </div>
                        <div className="thead-cell !w-27">
                            <div className="sort sort-disabled">
                                <span className="sort-label">{t('@Model@')}</span>
                                <span className="sort-arrow"><img src={ic_arrow_drop_down_svg} alt=""/></span>
                            </div>
                        </div>
                        <div className="thead-cell !w-33">
                            <div className="sort sort-disabled">
                                <span className="sort-label">{t('@Firmware@')}</span>
                                <span className="sort-arrow"><img src={ic_arrow_drop_down_svg} alt=""/></span>
                            </div>
                        </div>
                    </div>
                    <div className="flexbox-tbody overlay-scroll os-host-flexbox">
                        <div className="flexbox-trow flexbox-trow--no-margin">
                            <div className="tbody-cell !w-40">
                                <div className="device-name-group">
                                    <div className="device-img !mr-8">
                                        {state?.device_data?.model_info?.icon_url && <img src={state?.device_data?.model_info?.icon_url} alt={''}/>}
                                        {!state?.device_data?.model_info?.icon_url && <img src={ic_nas_0b_t1_svg} alt={''}/>}
                                    </div>
                                    <div className="device-name">{state?.device_data?.device_name}</div>
                                </div>
                            </div>
                            <div className="tbody-cell !w-27">{state?.device_data?.model_info?.name}</div>
                            <div className="tbody-cell !w-33">{state?.firmware}</div>
                        </div>
                    </div>
                </div>
                <div className="text-wrap mt-24">
                    <div className="fw5 mb-12">{t('@Important Information:@')}</div>
                    <ol>
                        <li>
                            {t('@Once transferred, this device will be managed under {{qid_email}}. Access Control will automatically be set to Private.@', {qid_email: email})}
                        </li>
                        <li>
                            {t("@SSL certificates using Let's Encrypt will remain valid, while TWCA certificates may require adjustments depending on the QTS version.@")}
                        </li>
                        <li>
                            {t('@The status of DDNS, myQNAPcloud Link, and AMIZcloud Agent will be retained unless manually changed on the device.@')}
                        </li>
                        <li>
                            {t('@Historical data (CPU/Memory/Storage Pool Usage, etc.) collected by AMIZcloud Agent will be retained unless manually cleared.@')}
                        </li>
                    </ol>
                </div>
                <div className="comp-checkbox-group">
                    <div className="comp-checkbox">
                        <input type="checkbox" id="cb-1" checked={agree} onChange={()=> setAgree(prev => !prev)} />
                        <label htmlFor="cb-1" className="comp-label"></label>
                    </div>
                    <div className="val-field !pl-0">
                        <span className="val-field__text">{t('@I understand and would like to continue the transfer.@')}</span>
                    </div>
                </div>
            </div>

        </ModalComponent>
    );
}

export default DeviceTransferToQid;